module.exports = __webpack_public_path__ + "static/img/logo01.add368e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo01.png
// module id = ywVb
// module chunks = 1